import request from '@/router/axios';

/** 仅巡检工单统计，不传班组与 scope */
export const getPersonnelSummary = (days = 7) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/summary',
    method: 'get',
    params: { days }
  });
};

export const getPersonnelStatusDistribution = (days = 7) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/status-distribution',
    method: 'get',
    params: { days }
  });
};

export const getPersonnelTeamLoad = (days = 7) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/team-load',
    method: 'get',
    params: { days }
  });
};

export const getPersonnelDaily = (days = 7) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/daily',
    method: 'get',
    params: { days }
  });
};

export const getPersonnelTopCompleted = (days = 7, limit = 10) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/top-completed',
    method: 'get',
    params: { days, limit }
  });
};

export const getPersonnelDetailPage = (days = 7, current = 1, size = 10) => {
  return request({
    url: '/api/produce/inspection-personnel-stats/detail-page',
    method: 'get',
    params: { days, current, size }
  });
};
